module.exports = __webpack_public_path__ + "img/provider_reg.7ec8d6f7.jpg";